"use client";

import { FC } from "react";
import { useSportFeedType } from "hooks/sportsbook/useSportFeedType";
import PoliciesSportsbookContentBC from "./components/PoliciesSportsbookContentBC";
import PoliciesSportsbookContent from "./components/PoliciesSportsbookContent";

type Props = {
    scope: string;
};

const PoliciesSportsbook: FC<Props> = ({ scope }) => {
    const { isBCFeed } = useSportFeedType();
    if (!scope) {
        return null;
    }

    return isBCFeed ? (
        <PoliciesSportsbookContentBC scope={scope} />
    ) : (
        <PoliciesSportsbookContent scope={scope} />
    );
};

export default PoliciesSportsbook;
